// extracted by mini-css-extract-plugin
export var phone = "_2h-0";
export var phoneDragging = "_2h-1";